import { render, staticRenderFns } from "./template-jobs.vue?vue&type=template&id=19c74110"
import script from "./template-jobs.vue?vue&type=script&lang=js"
export * from "./template-jobs.vue?vue&type=script&lang=js"
import style0 from "./template-jobs.vue?vue&type=style&index=0&id=19c74110&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports